import { FC, ReactNode } from 'react';
import { useTranslation } from 'next-i18next';
import { InfoBox } from '@components/info-box/info-box';
import Button from '@components/atoms/button/button';
import Icon from '@components/atoms/icon/icon';
import styles from './BannerBox.module.scss';

export type BannerBoxProps = {
  variant: 'info' | 'warning' | 'success' | 'danger';
  titleIcon: ReactNode;
  title: string;
  description?: string;
  onClickLearnMore?: () => void;
  showLearnMoreButton: boolean;
  onClickRecommendedPrice?: () => void;
  showRecommendedPriceButton: boolean;
  recommendedPrice: string;
};

export const BannerBox: FC<Partial<BannerBoxProps>> = ({
  variant,
  titleIcon,
  title,
  description,
  recommendedPrice,
  showLearnMoreButton,
  onClickLearnMore,
  showRecommendedPriceButton,
  onClickRecommendedPrice,
}) => {
  const { t } = useTranslation('price-drop');

  return (
    <InfoBox
      variant={variant}
      titleIcon={titleIcon}
      title={title}
      description={description}
    >
      {showLearnMoreButton && (
        <Button
          id="box-learn-more-button"
          type="button"
          className={styles.box__learnMoreButton}
          onClick={() => onClickLearnMore?.()}
        >
          {t('PRICE_DROP.PRICE_ZONE.LEARN_MORE')}
        </Button>
      )}
      {showRecommendedPriceButton && (
        <Button
          className={styles.box__showRecommendedPriceButton}
          variant="primary-white"
          size="large"
          fullWidth={true}
          onClick={() => onClickRecommendedPrice?.()}
        >
          <Icon
            name="reset-default"
            className={styles.box__ctaButton}
            ariaHidden
          />
          {t('PRICE_DROP.PRICE_ZONE.CTA', { formattedRecommendation: recommendedPrice })}
        </Button>
      )}
    </InfoBox>
  );
};
